import { Box } from "@govlaunch/web";
import React from "react";
import { ICardViewMode } from "~/src/components/collection/cardViewMode";
import { FormattedMessage } from "react-intl";

interface IBundleCollectionCardTotalProps {
  viewMode: ICardViewMode;
  total: number;
}

export default function BundleCollectionCardTotal({ viewMode, total }: IBundleCollectionCardTotalProps) {
  return (
    <Box
      position="absolute"
      bottom={viewMode === ICardViewMode.Bundles ? "12px" : "8px"}
      right={viewMode === ICardViewMode.Bundles ? "12px" : "8px"}
      color="gray.800"
      fontSize={["lg", "sm", "md", "md"]}
      fontWeight={["semibold", "normal", "normal", "normal"]}
    >
      <FormattedMessage defaultMessage="{total} Total" id="fkXl+5" values={{ total }} />
    </Box>
  );
}
